var authorsApp = Vue.createApp({
    data() {
        return {
            wawAuthors: halfBioList[halfBioListdivIdjs],
            selectedTopic: "",
            txtSearch: "",
            showCertifications: showCertifications,
            showEmail: showEmail,
            showCTA: showCTA,
            ctaText: ctaText,
            authorPage: 1,
            authorPerPage: recordsPerPage != 0 ? recordsPerPage : halfBioList[halfBioListdivIdjs].length,
            authorPages: [],
            totalNumberofAuthorPages: 0,
            divIdForScroll: halfBioListdivIdjs,
            readAuthorArticlesCTA: readAuthorArticlesCTA
        }
    },
    methods: {
        setAuthorPages(authors) {
            this.authorPages = [];
            this.totalNumberofAuthorPages = Math.ceil(authors.length / this.authorPerPage);
            this.authorPages = pagination(this.authorPage, this.totalNumberofAuthorPages);
        },
        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return items.slice(from, to);
        },
        resetPages() {
            this.authorPage = 1;
        },
        getImageMediaText(cmsImage) {
            return getOrchardImageMediaText(cmsImage);
        }

    },
    computed: {
        displayedAuthors() {
            halfBioListdivIdjs = halfBioListdivIdjs + 1;
            var filteredAuthors = this.wawAuthors.filter(function (item) {
                return (
                    (item.WaWAuthor.Name.Text != undefined && item.WaWAuthor.Name.Text.toLowerCase().includes(this.txtSearch.toLowerCase())
                        || (item.WaWAuthor.Designation.Text != undefined && item.WaWAuthor.Designation.Text.toLowerCase().includes(this.txtSearch.toLowerCase()))
                        || (item.WaWAuthor.Certifications.Text != undefined && item.WaWAuthor.Certifications.Text.toLowerCase().includes(this.txtSearch.toLowerCase()))
                        || (item.WaWAuthor.Email.Text != undefined && item.WaWAuthor.Email.Text.toLowerCase().includes(this.txtSearch.toLowerCase()))
                        || (item.WaWAuthor.ShortBio.Text != undefined && item.WaWAuthor.ShortBio.Text.toLowerCase().includes(this.txtSearch.toLowerCase()))
                        || this.txtSearch == "")
                    &&
                    (item.WaWAuthor.Taxonomy.TagNames != undefined && item.WaWAuthor.Taxonomy.TagNames.includes(this.selectedTopic) || this.selectedTopic == "")
                );
            }, this);

            this.setAuthorPages(filteredAuthors);
            if (paging == 'Show') {
                return this.paginate(filteredAuthors, this.authorPage, this.authorPerPage);
            }
            else {
                return filteredAuthors;
            }

        }
    },
    watch: {
        wawAuthors() {
            this.setAuthorPages();
        },
        authorPage: function (val) {
            scrollOnPagination("author_card_half_bio" + this.divIdForScroll);
        }
    },
});

try {
    var authorMountedApp = authorsApp.mount('#author_card_half_bio' + halfBioListdivIdjs);
}
catch (ex) {

}